import "./admin-workspace-switcher.css";

export type AdminWorkspaceName = "bookings" | "events" | "health" | "proposals" | "legacy";

export function AdminWorkspaceSwitcher({ active }: { active: AdminWorkspaceName }) {
  const requestedPerson = new URLSearchParams(window.location.search).get("person");
  const person =
    requestedPerson === "katrin" ||
    (requestedPerson !== "rayk" &&
      window.location.hostname.toLowerCase() === "book.katrinschoerling.com")
      ? "katrin"
      : "rayk";

  return (
    <nav className="admin-workspace-switcher" aria-label="Booking-Verwaltung">
      <a
        className={active === "bookings" && person === "rayk" ? "is-active" : ""}
        href="/?admin=1&person=rayk"
      >
        Rayk · 1:1
      </a>
      <a
        className={active === "bookings" && person === "katrin" ? "is-active" : ""}
        href="/?admin=1&person=katrin"
      >
        Katrin · 1:1
      </a>
      <a className={active === "events" ? "is-active" : ""} href="/?admin=events">
        Veranstaltungen
      </a>
      <a className={active === "proposals" ? "is-active" : ""} href="/?admin=proposals">
        Vorschläge
      </a>
      <a className={active === "health" ? "is-active" : ""} href="/?admin=health">
        System
      </a>
    </nav>
  );
}
